import debounce                     from 'lodash.debounce';
import categoryButton               from './faq-form-category-button';

/**
 * FAQ Form
 * The faq form module handles the searching part of the FAQ.
 */
function faqSearchForm(el, faq, app) {
    const $el                       = $(el);
    const $search                   = $el.find('[data-js-faq-search]');
    const $label                    = $el.find('[data-js-faq-label]');
    const $searchClear              = $el.find('[data-js-faq-search-clear]');

    $search.on('keydown', (evt) => {
        if (evt.which === 13) {
            evt.preventDefault();
        }
    });

    // attach event listeners
    $search.on('input', debounce(() => {
        let query = $search.val().trim();
        if (query && query.length < 3) { return; }

        // empty string maybe? make it undefined
        if (!query) { query = undefined; }

        faq.setParams({
            query: query,
            commonSearch: undefined,
            category: undefined,
            question: undefined
        }, { replace: true });

    }, 350));

    $searchClear.click((evt) => {
        evt.preventDefault();
        $search.val('');
        faq.setParams({
            query: undefined,
            commonSearch: undefined,
            category: undefined
        });
        $label.removeClass('Ge-Label--loaded');
        app.trigger('beacon','faq-search-clear');
    });

    faq.on('param:query', (query) => {
        $searchClear.toggleClass('Ge-Form-Icon--Hidden', !query);
    });

    setTimeout(function(el) {
        $search.val(faq.getParams('query'));
        $search.trigger('fieldValidate',[true]);
    }, 0);

    return {};
};

export default faqSearchForm;
